module.exports = __webpack_public_path__ + "static/media/Corded_ware_germany_text_02.5fb78330.jpg";